import { SEOProps } from '@/components/ui/SEO';

export const CONDITIONS_GENERALES_UTILISATION_SEO: SEOProps = {
  title: 'Conditions générales d&apos;utilisation | zLawyer - Logiciel de gestion pour avocats',
  description:
    'Conditions générales d&apos;utilisation pour le site zLawyer. Découvrez comment nous utilisons les cookies pour améliorer votre expérience sur notre site.',
  url: 'https://www.zlawyer.fr/logiciel-avocats/conditions-generales-utilisation/',
};

export default function ConditionsGeneralesUtilisation() {
  return (
    <div className="max-width-blue-section">
      <h2 className="mb-20 text-center">Conditions générales d&apos;utilisation du site zLawyer</h2>

      <h3>1. L&apos;utilisation de cookies</h3>
      <p>
        Notre site internet zLawyer utilise des cookies. Un cookie est un petit fichier qui est
        envoyé avec les pages de ce site Web et/ou les applications Flash et qui est stocké par
        votre navigateur sur votre disque dur à partir de votre ordinateur, téléphone portable,
        montre connectée ou tablette. Les informations qui y sont stockées peuvent être retournées à
        nos serveurs lors d&apos;une visite ultérieure.
      </p>
      <br />
      <p>
        L&apos;utilisation de cookies est d&apos;une grande importance pour le bon fonctionnement de
        notre site web. Grâce à la contribution (anonyme) des visiteurs, nous pouvons améliorer
        l&apos;utilisation du site internet et le rendre plus convivial.
      </p>

      <hr className="my-10" />

      <h3>2. Consentement</h3>
      <p>
        Votre consentement est requis pour l&apos;utilisation de certains cookies. Nous le
        recueillons au moyen d&apos;une bannière informative.
      </p>

      <hr className="my-10" />

      <h3>3a. Le type de cookies utilisés et leurs objectifs</h3>
      <p>Nous utilisons les cookies suivants :</p>
      <br />
      <ul className="ml-8" style={{ listStyleType: 'disc' }}>
        <li>
          Cookies fonctionnels : ils nous permettent d&apos;améliorer le fonctionnement du site
          internet et de le rendre plus convivial pour le visiteur. Par exemple, nous stockons vos
          données de connexion.
        </li>
        <li>
          Cookies de mesure d&apos;audience : ils garantissent qu&apos;un cookie anonyme est généré
          à chaque fois que vous visitez un site internet. Ces cookies permettent de savoir si vous
          avez déjà visité le site auparavant ou non. Ce n&apos;est que lors de la première visite
          qu’un cookie est créé. Lors des visites suivantes, l&apos;utilisation du cookie déjà
          existant est automatique. Ce cookie n&apos;est utilisé qu&apos;à des fins statistiques. De
          cette façon, les données suivantes peuvent être collectées :
        </li>
      </ul>
      <br />
      <ul className="ml-16" style={{ listStyleType: 'circle' }}>
        <li>le nombre de visiteurs uniques;</li>
        <li>la fréquence à laquelle les utilisateurs visitent le site</li>
        <li>quelles pages les visiteurs consultent</li>
        <li>combien de temps les utilisateurs consultent une page particulière</li>
        <li>la page à partir de laquelle les visiteurs quittent le site</li>
      </ul>

      <hr className="my-10" />

      <h3>3b. Liste des cookies utilisés</h3>
      <p>
        Cookies Google : · Google analytics : permet de mesurer l&apos;audience du site. · Google
        tag manager : facilite l’implémentation des tags sur les pages et permet de gérer les
        balises Google. · Google Adsense : régie publicitaire de Google utilisant les sites web ou
        les vidéos YouTube comme support pour ses annonces. · Google Dynamic Remarketing : permet de
        vous proposer de la publicité dynamique en fonction des précédentes recherches. · Google
        Adwords Conversion : outil de suivi des campagnes publicitaires adwords. · DoubleClick :
        cookies publicitaires de Google pour diffuser des bannières.
      </p>

      <hr className="my-10" />

      <h3>4. Vos droits à l&apos;égard de vos données personnelles</h3>
      <p>
        Vous disposez d&apos;un droit d&apos;accès, de rectification, de limitation et de
        suppression de vos données personnelles. En outre, vous avez le droit de vous opposer au
        traitement des données personnelles et le droit à la transférabilité de vos données. Vous
        pouvez exercer ces droits en nous envoyant un mail à l&apos;adresse suivante{' '}
        <a className="text-link" href="mailto:contact@zele-solutions.fr">
          contact@zele-solutions.fr
        </a>
        . Afin de prévenir les abus, nous pouvons vous demander de vous identifier sur notre site.
        Lorsqu&apos;il s&apos;agit d&apos;accéder à des données personnelles liées à un cookie, nous
        vous demandons de nous envoyer une copie du cookie en question. Vous pouvez les trouver dans
        les paramètres de votre navigateur.
      </p>

      <hr className="my-10" />

      <h3>5. Blocage et suppression des cookies</h3>
      <p>
        Vous pouvez facilement bloquer et supprimer vous-même les cookies à tout moment par votre
        navigateur Internet. Vous pouvez également configurer votre navigateur Internet de manière à
        recevoir un message lorsqu&apos;un cookie est installé. Vous pouvez également indiquer que
        certains cookies ne peuvent pas être installés. Pour cela, veuillez consultez la fonction
        d&apos;aide de votre navigateur. Si vous supprimez les cookies de votre navigateur, cela
        peut avoir des conséquences sur l&apos;utilisation de notre site internet. Certains cookies
        de suivi sont installés par des tiers qui vous affichent des publicités via notre site Web.
        Vous pouvez supprimer ces cookies de manière centralisée via www.youronlinechoices.eu.
        Veuillez noter que si vous ne voulez pas de cookies, nous ne serons plus en mesure de
        garantir le bon fonctionnement de notre site Web. Certaines caractéristiques du site peuvent
        être altérées et dans certains cas, vous ne pourrez plus accéder au site. De plus, le refus
        des cookies ne signifie pas que vous ne verrez aucune publicité. Les annonces ne sont plus
        adaptées à vos centres d&apos;intérêt et peuvent donc apparaître plus souvent. Les étapes à
        suivre pour ajuster vos paramètres varient d&apos;un navigateur à un autre. Si nécessaire,
        consultez la fonction d&apos;aide de votre navigateur, ou rendez-vous sur l’un des liens
        ci-dessous pour accéder directement au manuel de votre navigateur.
      </p>
      <br />
      <ul className="ml-8" style={{ listStyleType: 'disc' }}>
        <li>
          Firefox :{' '}
          <a
            className="text-link"
            href="https://support.mozilla.org/fr/kb/effacer-les-cookies-pour-supprimer-les-information"
            rel="noreferrer"
            target="_blank"
          >
            https://support.mozilla.org/fr/kb/effacer-les-cookies-pour-supprimer-les-information
          </a>
        </li>
        <li>
          Google Chrome :{' '}
          <a
            className="text-link"
            href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform=Desktop&hl=fr"
            rel="noreferrer"
            target="_blank"
          >
            https://support.google.com/chrome/answer/95647?co=GENIE.Platform=Desktop&hl=fr
          </a>
        </li>
        <li>
          Internet Explorer :{' '}
          <a
            className="text-link"
            href="https://support.microsoft.com/fr-fr/help/278835/how-to-delete-cookie-files-in-internet-explorer"
            rel="noreferrer"
            target="_blank"
          >
            https://support.microsoft.com/fr-fr/help/278835/how-to-delete-cookie-files-in-internet-explorer
          </a>
        </li>
        <li>
          Safari :{' '}
          <a
            className="text-link"
            href="https://support.apple.com/kb/ph31411?locale=fr_FR"
            rel="noreferrer"
            target="_blank"
          >
            https://support.apple.com/kb/ph31411?locale=fr_FR
          </a>
        </li>
      </ul>

      <hr className="my-10" />

      <h3>6. Nouveaux développements et cookies non prévus</h3>
      <p>
        Sur certaines de nos pages, nous pouvons utiliser du contenu qui est hébergé sur
        d&apos;autres sites et qui est rendu accessible sur notre site internet au moyen de certains
        codes (contenu intégré). Ces codes utilisent souvent des cookies. Nous n’avons cependant
        aucun contrôle sur ce que ces tiers font de leurs cookies. Il est également possible que,
        par l&apos;intermédiaire de notre site internet, des cookies soient placés par d&apos;autres
        personnes. Vous avez trouvé sur notre site internet des cookies que nous n&apos;avons pas
        identifiés ? Veuillez nous le faire savoir par mail. Vous pouvez également contacter
        directement le tiers et lui demander quels cookies il place, quelle en est la raison, quelle
        est la durée de vie du cookie et quelles sont les mesures pour protéger votre vie privée.
      </p>

      <hr className="my-10" />

      <h3>7. Remarques</h3>
      <p>
        Nous devrons mettre à jour cette politique d&apos;utilisation des cookies régulièrement, par
        exemple lorsque nous modifions notre site Web ou les règles le concernant. Nous vous prions
        de consulter cette page pour prendre connaissance de la dernière version de notre politique
        d&apos;utilisation des cookies. Si vous avez des questions et/ou des commentaires, veuillez
        nous contacter à l&apos;adresse e-mail suivante :{' '}
        <a className="text-link" href="mailto:contact@zele-solutions.fr">
          contact@zele-solutions.fr
        </a>
      </p>
    </div>
  );
}

ConditionsGeneralesUtilisation.seo = CONDITIONS_GENERALES_UTILISATION_SEO;
